import { norm, openLink, getGameStates, getBettingData, getLeagueContainer, getGridClass } from "../../../../functions/functions.js";
import { useLeagueToggle } from "../../../../hooks/useLeagueToggle.js";
import PeriodTitle from "../reusablesComponent/periodTitle.js";
import SecondaryTitle from "../reusablesComponent/subtitle.js";
import TeamsBaseballComponent from "./teamsBaseball.js";
import FooterCard from "../reusablesComponent/footerCard.js";
import ScoreBaseballComponent from "./scoreBaseball.js";
import PitchersComponent from "./pitchers.js";
import MomiosComponent from "../reusablesComponent/momiosGeneral.js";
import BaseballDiamond from "../../../reusablesComponents/baseballDiamond.js";
import MovesNFLComponent from "./movesNFL.js";
import BotonApostarHub from "../reusablesComponent/buttonApostar.js";
import './cardBaseball.sass'


export default function CardBaseball({
  leagues = [],
  mostrarMomios,
  url = "/assets/",
  mostrarBotonApostar = true,
  isStrendus = false
}) {

  const { openMap } = useLeagueToggle(leagues);

  return (
    <>
      {leagues.map((league, leagueIdx) => {
        const { contId, id, visible, key } = getLeagueContainer(league, leagueIdx, openMap);

        return (
          <div key={key} className={`${getGridClass(league.games?.length)}`}>
            <SecondaryTitle
              leagueName={league.name}
              isVisible={visible}
              linkLiga={league.url}
              leagueImage={league.image}
            />

            <div
              id={contId}
              className="content-list-cards content-baseball"
              style={{ display: "grid" }}
            >
              {Array.isArray(league.games) &&
                league.games.map((item, gameIdx) => {
                  const { time_format, cls: gameClass, isFinished, isError: isErrorGame } = getGameStates(item);
                  const { hasMm, apostarHref } = getBettingData(item, isStrendus);

                  const { utc_date, period_title, opta_event_url, venue_name, venue_country, venue_state, baseball_data, sport } = item;

                  const shouldShowButton = mostrarBotonApostar === 'true' && !isFinished && !isErrorGame;
                  const shouldMomios = mostrarMomios === true && !isFinished && !isErrorGame;

                  return (
                    <div key={gameIdx} className="card-complete-event card-complete-baseball">
                      <div className={sport === 'BASE' ?"card-game card-game-baseball" :"card-game"}>

                        {sport === 'BASE' && <PeriodTitle
                          clase={item.class}
                          opta_event_url={opta_event_url}
                          period_title={period_title}
                          utc_date={utc_date}
                          time_format={time_format}
                          isTenis={false}
                          tenis_fase=""
                        />
                        }

                        <div className="card-body" onClick={() => openLink(opta_event_url, true)}>

                          <TeamsBaseballComponent item={item} url={url} />

                          {shouldMomios && hasMm && (
                            <MomiosComponent
                              isFinOrError={isErrorGame || isFinished}
                              item={item}
                              isStrendus={isStrendus}
                            />
                          )}

                          {sport === 'BASE' && (gameClass !== 'clarosports-finished-game' && gameClass !== 'clarosports-in-progress-game') &&
                            baseball_data?.left_stats?.start_pitcher && baseball_data?.right_stats?.start_pitcher
                            ? (<PitchersComponent item={item} />)
                            : (gameClass !== "clarosports-next-game" && !isErrorGame) && (
                              <ScoreBaseballComponent
                                item={item}
                                norm={norm}
                                clickScore={() => openLink(opta_event_url, true)}
                              />
                            )}

                          {sport != 'BASE' && <PeriodTitle
                            clase={item.class}
                            opta_event_url={opta_event_url}
                            period_title={period_title}
                            utc_date={utc_date}
                            time_format={time_format}
                            isTenis={false}
                            tenis_fase=""
                          />
                          }

                          {sport === 'BASE' && gameClass === 'clarosports-in-progress-game' &&
                            <BaseballDiamond sport={sport} baseball_data={baseball_data} islive={gameClass === "clarosports-in-progress-game"} />
                          }
                          {sport === 'AMFO' && gameClass === 'clarosports-in-progress-game' &&
                            <MovesNFLComponent item={item} />
                          }

                        </div>

                        {shouldShowButton &&
                          <BotonApostarHub
                            mostrarBotonApostarCard={shouldShowButton}
                            isStrendus={isStrendus}
                            apostarHref={apostarHref}
                          />
                        }

                        <FooterCard
                          estadio={venue_name}
                          ciudad={venue_state}
                          estado={venue_country}
                          opta_event_url={opta_event_url}
                          clase={item.class}
                          period_title={period_title}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        );
      })}
    </>
  );
}